<template>
  <div>
    <div class="w-full bg-black" style="height: 27rem">
      <img src="../assets/home/bottomglobal.png" class="h-full" alt="" />
      <div class="flex space-x-4 h-80 flex-wrap" style="margin-top: -24rem">
        <!-- 1 -->
        <div class="flex-1 box-border center h-hull w-32 p-4">
          <div class="flex-1 center box-border space-x-4 h-full">
            <div class="">
              <!-- <img src="../assets/home/logocolor.png" alt="" /> -->
              <img
                class="mb-10"
                src="../assets/home/logowhite.png"
                style="width: 14.25rem"
              />
              <p class="text-white text-lg">
                {{ $t("bottom.hangzhouGreenPalm") }}
              </p>
              <div class="inset-x-0 bottom-0 mt-18">
                <p class="text-white mt-5 font-bold">
                  {{ $t("bottom.community") }}
                </p>
                <div class="flex mt-3">
                  <div class="icon">
                    <img
                      class="mr-5 icon"
                      @click="imgleft"
                      style="
                        border: 1px solid #313131;
                        background-color: #1b1b1b;
                      "
                      src="../assets/home/discord.png"
                      alt=""
                    />
                  </div>
                  <div class="icon">
                    <img
                      @click="imgRight"
                      style="
                        border: 1px solid #313131;
                        background-color: #1b1b1b;
                      "
                      src="../assets/home/Twitter.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- icon -->
          </div>
          <div class="flex-1 center box-border space-x-4 h-full">
            <div class="text-white">
              <div class="mb-3 font-semibol w-80 font-bold">
                {{ $t("bottom.navigation") }}
              </div>
              <div class="home-line"></div>
              <div style="border-bottom: 1px solid #383838" class="mb-10"></div>
              <div class="flex">
                <p class="mr-2 text-green-600">-</p>
                <router-link to="/home"
                  ><p class="mb-5">
                    {{ $t("bottom.home") }}
                  </p></router-link
                >
              </div>
              <div class="flex">
                <p class="mr-2 text-green-600">-</p>
                <router-link to="/solution"
                  ><p class="mb-5">
                    {{ $t("bottom.solution") }}
                  </p></router-link
                >
              </div>
              <div class="flex shopstyle">
                <p class="mr-2 text-green-600">-</p>
                <p class="mb-5" @click="shop">
                  {{ $t("bottom.shop") }}
                </p>
              </div>
              <div class="flex">
                <p class="mr-2 text-green-600">-</p>
                <router-link to="/customization"
                  ><p class="mb-5">
                    {{ $t("bottom.customization") }}
                  </p></router-link
                >
              </div>
              <div class="flex">
                <p class="mr-2 text-green-600">-</p>
                <router-link to="/aboutus"
                  ><p class="mb-5">
                    {{ $t("bottom.aboutUs") }}
                  </p></router-link
                >
              </div>
            </div>
          </div>
          <div class="flex-1 box-border space-x-4 h-full">
            <div class="">
              <div class="mb-3 mt-5 text-white font-bold">
                {{ $t("bottom.contactUs") }}
              </div>
              <div class="home-line"></div>
              <div style="border-bottom: 1px solid #383838" class="mb-10"></div>
              <div class="flex">
                <img
                  class="w-3 h-4 mr-2 mt-1"
                  src="../assets/icon/address.png"
                  alt=""
                />
                <router-link to="#"
                  ><p class="text-white w-72 tracking-wide leading-6">
                    {{ $t("bottom.room") }}
                  </p></router-link
                >
              </div>
              <div class="flex mt-10">
                <img
                  class="w-4 h-3 mr-2 mt-1"
                  src="../assets/icon/email.png"
                  alt=""
                />
                <router-link to="#"
                  ><p class="mb-5 text-white">
                    {{ $t("bottom.trade") }}
                  </p></router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="py-6 text-white text-center bg-black floor-5  flex justify-center">
      <a class="realm-a" href="https://beian.miit.gov.cn" target="_blank">
          {{ $t("bottom.copyright") }}</a
        >
       <a style="margin-left:50px" href="https://v6.51.la/land/Jk2o3PcygQNyg0jO" target="_blank"> <img src="https://sdk.51.la/icon/1-3.png"></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "https://greenpalmiot.com/",
      imgUrlLeft: "https://discord.gg/huXkQbkJDW",
      imgUrlRight: "https://twitter.com/GreenPalmIoT",
    };
  },
  methods: {
    shop() {
      window.open(this.url, "_blank");
      // window.location.href = this.url;
    },
    imgleft() {
      window.open(this.imgUrlLeft, "_blank");
      // window.location.href = this.imgUrlLeft;
    },
    imgRight() {
      window.open(this.imgUrlRight, "_blank");
      // window.location.href = this.imgUrlRight;
    },
  },
};
</script>

<style lang="less" scoped>
.home-line {
  width: 4rem;
  border-top: 3px solid green;
}
.bottom-line {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.shopstyle :hover {
  cursor: pointer;
}
.icon :hover {
  cursor: pointer;
}
// .homelobal {
//    url:("../assets/home/bottomglobal.png");
// }
.bgimg {
  background: url("../assets/home/bottomglobal.png") no-repeat;
  background-color: black;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/bottomInfo.vue